var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('product-form',{on:{"save":_vm.save,"back":_vm.back},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}}):_c('loading-page')}
var staticRenderFns = []

export { render, staticRenderFns }